import { DashboardBaseSteps, DashboardPurchasingSteps } from "src/pages/dashboard/helpers/DashboardSteps";
import { EditProductsSteps } from "src/pages/products/products/EditProductsSteps";
import { ProductsSteps } from "src/pages/products/products/ProductsSteps";
import { SupplierProductsSteps } from "src/pages/products/supplierProducts/SupplierProductsSteps";

const TourStepMapping = { Products: ProductsSteps, EditProduct: EditProductsSteps, Dashboard: DashboardBaseSteps, "Purchasing Intro": DashboardPurchasingSteps, SupplierProducts: SupplierProductsSteps, };

export default TourStepMapping;
